import React from "react";
import MultiSelectField from "../Placementdb/MultiSelectField";
import DateRangePicker from "../Placementdb/DateRangePicker";

const ReportFiltersPanel = ({
  branches,
  departments,
  courses,

  locations,
  selectedLocations,
  setSelectedLocations,

  selectedBranches,
  selectedDepartments,
  selectedCourses,

  setSelectedBranches,
  setSelectedDepartments,
  setSelectedCourses,

  selectedPlacedBy,
  setSelectedPlacedBy,
  packageRange,
  setPackageRange,
  placementDateFrom,
  setPlacementDateFrom,
  placementDateTo,
  setPlacementDateTo,
  placementStatusFilter,
  setPlacementStatusFilter,
  placementOfficers,

  onApply,
  onClear
}) => {
  return (
    <div className="advanced-filters-panel">

      <div className="filters-grid">
        {/* Location */}
        <MultiSelectField
          label="Location"
          options={locations}
          selectedValues={selectedLocations}
          onChange={setSelectedLocations}
          placeholder="Select locations..."
          searchPlaceholder="Search locations..."
        />
        {/* Branch */}
        <MultiSelectField
          label="Branch"
          options={branches}
          selectedValues={selectedBranches}
          onChange={setSelectedBranches}
          placeholder="Select branches..."
          searchPlaceholder="Search branches..."
        />

        {/* Department */}
        <MultiSelectField
          label="Department"
          options={departments}
          selectedValues={selectedDepartments}
          onChange={(values) => {
            setSelectedDepartments(values);
            setSelectedCourses([]); // reset course when dept changes
          }}
          placeholder="Select departments..."
          searchPlaceholder="Search departments..."
        />

        {/* Course */}
        <MultiSelectField
          label="Course"
          options={courses}
          selectedValues={selectedCourses}
          onChange={setSelectedCourses}
          placeholder={
            selectedDepartments.length === 0
              ? "Select department first"
              : "Select courses..."
          }
          searchPlaceholder="Search courses..."
          disabled={selectedDepartments.length === 0}
        />
        <MultiSelectField
          label="Placed By"
          options={['Self (Student)', 'Others', ...placementOfficers]}  // ✅ FIX
          selectedValues={selectedPlacedBy}
          onChange={setSelectedPlacedBy}
        />
        <div className="multi-select-field">
          <label>Package Range:</label>
          <select
            value={packageRange}
            onChange={(e) => setPackageRange(e.target.value)}
          >
            <option value="">All</option>
            <option value="<2">&lt; 2 LPA</option>
            <option value="2-4">2 - 4 LPA</option>
            <option value="4-6">4 - 6 LPA</option>
            <option value=">6">&gt; 6 LPA</option>
          </select>
        </div>
        <DateRangePicker
          dateFrom={placementDateFrom}
          dateTo={placementDateTo}
          onDateFromChange={setPlacementDateFrom}
          onDateToChange={setPlacementDateTo}
          label="Placement Date Range"
        />
        <div className="multi-select-field">
          <label>Status:</label>
          <select
            value={placementStatusFilter}
            onChange={(e) => setPlacementStatusFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Placed">Placed</option>
            <option value="Placed but not accepted the Offer">
              Placed but not accepted
            </option>
          </select>
        </div>
      </div>

      {/* Actions */}
      <div className="filters-actions">
        <button onClick={onClear} className="clear-btn">
          Clear All filters
        </button>

        {/* <button onClick={onApply} className="apply-filters-btn">
          Apply
        </button> */}
      </div>

    </div>
  );
};

export default ReportFiltersPanel;